import { render, staticRenderFns } from "./QaCategoryList.vue?vue&type=template&id=1cd49aba&scoped=true&"
import script from "./QaCategoryList.vue?vue&type=script&lang=js&"
export * from "./QaCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./QaCategoryList.vue?vue&type=style&index=0&id=1cd49aba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd49aba",
  null
  
)

export default component.exports